// Module
var code = "<template>\n  <require from=\"../../../../features/mooring/article-categorization/mooring-article-category-container\"></require>\n\n  <mooring-article-category-container></mooring-article-category-container>\n</template>\n";
// Exports
export default code;